import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV, APPLY_URL } from "../../data/mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on); on();
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${scrolled ? "backdrop-blur-md bg-[rgba(10,9,8,0.72)] border-b hairline" : "bg-transparent"}`}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="font-display text-[22px] leading-none tracking-tight">27:17</div>
            <div className="absolute -right-2 -top-1 w-1 h-1 rounded-full bg-[var(--ember-2)] ember-dot"></div>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-[var(--text-muted)] hidden sm:block">Performance</div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)] hover:text-[var(--text)] transition-colors relative group">
              {n.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 group-hover:w-full transition-all duration-500 bg-[var(--ember-2)]"></span>
            </a>
          ))}
        </nav>

        <a href={APPLY_URL} target="_blank" rel="noreferrer" className="hidden md:inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] px-4 py-3 border hairline-2 hover:border-[var(--ember-2)] hover:text-[var(--ember-2)] transition-colors">
          Apply <ArrowUpRight size={14} />
        </a>

        <button className="lg:hidden text-[var(--text)]" onClick={() => setOpen(true)} aria-label="Menu"><Menu /></button>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-[var(--bg)] flex flex-col p-8">
          <div className="flex items-center justify-between">
            <div className="font-display text-2xl">27:17</div>
            <button onClick={() => setOpen(false)} aria-label="Close"><X /></button>
          </div>
          <nav className="mt-16 flex flex-col gap-6">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="font-display text-4xl tracking-tight hover:text-[var(--ember-2)] transition-colors">{n.label}</a>
            ))}
            <a href={APPLY_URL} target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="btn-ember mt-10 self-start">Begin Application <ArrowUpRight size={16}/></a>
          </nav>
        </div>
      )}
    </header>
  );
}
